// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"404":"2c4509a9","841":"c4951dc2","937":"d73190b5"}[chunkId] + ".js";
};